/** Where the visualizer reports send a vendor — one place, so a moved page is one edit. */
export const VIZ_LINKS = {
  dashboard: '/visualizer/dashboard',
  analytics: '/visualizer/engagement/analytics?tab=overview',
  searches: '/visualizer/engagement/analytics?tab=overview#searches',
  products: '/visualizer/engagement/analytics?tab=products',
  activity: '/visualizer/engagement/activity',
  leads: '/visualizer/engagement/leads',
  leadsWaiting: '/visualizer/engagement/leads?filter=waiting',
  install: '/visualizer/settings?tab=button',
  productDisplay: '/visualizer/settings?tab=product-display',
  features: '/visualizer/settings?tab=features',
  catalog: '/products/catalog',
  newProduct: '/products/new',
  importProducts: '/products/import',
  automation: '/marketing/email/automation',
  plans: '/home/billing/plan',
  compose: (email: string) => `/marketing/email/compose?email=${encodeURIComponent(email)}`,
  editProduct: (uuid: string) => `/products/${encodeURIComponent(uuid)}/edit`,
  activityFor: (email: string) => `/visualizer/engagement/activity?email=${encodeURIComponent(email)}`,
} as const;
